<template>
	<div class="gateway" :style="{'height': clientHeight+'px' }">
		<!--网关-->
		<div class="headerBox3">
			<div class="leftContent">
				<div class="modelClass">设备型号：{{rowObj.model}}</div>
				<div class="setNameClass">{{String(rowObj.name).replace(/\s/g,"&ensp;")}}</div>
				<div class="typeClass" v-if="!boxShow">{{urlValue}}/{{rowObj.name}}</div>
				<div class="textClass1" v-if="boxShow">阿里名称：{{equimentName}}</div>
				<div class="textClass" v-if="boxShow">设备编号：{{equimentCode}}</div>
				<div class="textClass" v-if="boxShow">通讯地址：{{addr}}</div>
				<div class="textClass" v-if="boxShow">备注：{{remarkValue}}</div>
				<div class="typeClass2" v-if="boxShow">{{urlValue}}/{{String(rowObj.name).replace(/\s/g,"&ensp;")}}</div>
			</div>
			<div class="rightContent">
				<div style="display: inline-block;width:24%;vertical-align: top;margin-top:2%;">
					<div class="setStatusClass">设备状态</div>
					<div class="outLineClass" v-if="use_status==0"><i class="iconfont icon-wuWIFI wifiClass"></i>离线</div>
					<div class="outLineClass" v-if="use_status==1"><i class="iconfont icon-WIFI wifiClass2"></i>在线</div>
				</div>
				<div style="display: inline-block;width:70%;margin-top:2%;">
					<div class="MeiClass" v-if="boxShow">IMEI：{{hei}}</div>
					<div class="MeiClass" v-if="boxShow">IMSI：{{imsi}}</div>
					<div class="MeiClass" v-if="boxShow">ICCID：{{iccid}}</div>
				</div>
				<el-button type="primary" @click="ebtryGatewayClick('编辑网关')" class="relationButton3" v-if="boxShow">编辑网关</el-button>
				<el-button type="primary" @click="transClick()" class="relationButton" v-if="boxShow">透传</el-button>
				<el-button type="primary" @click="timingClick()" class="relationButton1" v-if="boxShow">校时</el-button>
				<el-button type="primary" @click="ebtryGatewayClick('录入网关')" class="relationButton2">录入网关</el-button>
			</div>
		</div>
		<div style="position: relative;margin-top: 20px;" v-if="boxShow">
			<el-radio-group v-model="tabPosition" style="margin-bottom: 4px;" @change="tabClick">
				<el-radio-button label="设备">设备</el-radio-button>
				<el-radio-button label="方案">方案</el-radio-button>
				<el-radio-button label="任务">任务</el-radio-button>
				<el-radio-button label="上报历史">上报历史</el-radio-button>
			</el-radio-group>
			<div class="tabButtonBox">
				<el-button type="primary" class="tabButton2" @click="batchDeleteClick()" v-if="tableShow1">批量删除</el-button>
				<el-button type="primary" class="tabButton2" @click="batchCopyClick()" v-if="tableShow1">批量扩展录入</el-button>
				<el-button type="primary" @click="readFileClick()" class="tabButton" v-if="tableShow1&&setingList.length>0">读取档案</el-button>
				<el-button type="primary" @click="kongFileClick()" class="tabButton" v-if="tableShow1">清空档案</el-button>
				<el-button type="primary" @click="sendFileClick()" class="tabButton" v-if="tableShow1">下发档案</el-button>
				<el-button type="primary" @click="addSetClick()" class="tabButton" v-if="tableShow1">新增设备</el-button>
				<el-button type="primary" @click="readCollectClick()" class="tabButton" v-if="tableShow2">读取方案</el-button>
				<el-button type="primary" @click="kongCollectClick()" class="tabButton" v-if="tableShow2">清空方案</el-button>
				<el-button type="primary" @click="sendCollectClick()" class="tabButton" v-if="tableShow2">下装方案</el-button>
				<el-button type="primary" @click="projectClick()" class="tabButton" v-if="tableShow2">组织方案</el-button>
				<el-button type="primary" @click="readTaskClick()" class="tabButton" v-if="tableShow3">读取任务</el-button>
				<el-button type="primary" @click="kongTaskClick()" class="tabButton" v-if="tableShow3">清空任务</el-button>
				<el-button type="primary" @click="sendTaskClick()" class="tabButton" v-if="tableShow3">下发任务</el-button>
				<el-button type="primary" @click="taskClick()" class="tabButton" v-if="tableShow3">组织任务</el-button>
			</div>
		</div>
		<div v-if="boxShow">
			<!--1-设备表格-->
			<el-table :data="setingList" style="width: 100%" v-show="tableShow1" class="tabPositionClass" @selection-change="handleSelectionChange" ref="multipleTable">
				<el-table-column label="选取" type="selection" width="55" style="height:20px">
				</el-table-column>
				<el-table-column label="序 号" width="70">
					<template slot-scope="scope"><span style="padding-left: 4px;">{{(pageIndex2-1)*pageSize+scope.$index+1}}</span></template>
				</el-table-column>
				<el-table-column prop="" label="型号" width="150">
					<template slot-scope="scope">{{scope.row.model}}</template>
				</el-table-column>
				<el-table-column prop="" label="通讯地址" width="150">
					<template slot-scope="scope">{{scope.row.addr}}</template>
				</el-table-column>
				<el-table-column prop="" label="用户类型" min-width="90">
					<template slot-scope="scope">{{scope.row.user_type}}</template>
				</el-table-column>
				<el-table-column prop="" label="端口" width="150">
					<template slot-scope="scope">{{scope.row.port|portFilter}}</template>
				</el-table-column>
				<el-table-column prop="" label="波特率" width="150">
					<template slot-scope="scope">{{scope.row.rate_type|rate_typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="ruler_type" label="规约类型" width="150">
					<template slot-scope="scope">{{scope.row.ruler_type|ruler_typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="" label="电压变比" width="150">
					<template slot-scope="scope">{{scope.row.rate_v}}</template>
				</el-table-column>
				<el-table-column prop="" label="电流变比" width="150">
					<template slot-scope="scope">{{scope.row.rate_a}}</template>
				</el-table-column>
				<el-table-column prop="password" label="密码" width="150">
					<template slot-scope="scope">{{scope.row.password}}</template>
				</el-table-column>
				</el-table-column>
				<el-table-column prop="" fixed="right" label="操作" width="150">
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="enterClick(scope.row.id,scope.row)">扩展录入</a>
						<a class="editClass" @click.prevent="deleteClick('设备',scope.row.id)">删除</a>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination" v-if="tableShow1">
				<el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total1" v-if="total1>20">
				</el-pagination>
			</div>
			<!--2-方案表格-->
			<el-table :data="collectList" style="width: 100%" v-show="tableShow2" class="tabPositionClass">
				<el-table-column prop="" label="方案编号" min-width="1%">
					<template slot-scope="scope">{{scope.row.case_no}}</template>
				</el-table-column>
				<el-table-column prop="case_type" label="方案类型" min-width="1%">
					<template slot-scope="scope">{{scope.row.case_type|case_typeFilter}}</template>
				</el-table-column>
				<!--<el-table-column prop="address" label="系统类型" min-width="1%">
				</el-table-column>-->
				<!--<el-table-column prop="date" label="相关设备" min-width="1%">
				</el-table-column>-->
				<el-table-column prop="collect_type" label="采集类型" min-width="1%">
					<template slot-scope="scope">{{scope.row.collect_type|collect_typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="collect_type" label="用户类型" min-width="2%">
					<template slot-scope="scope">{{scope.row.ms_user}}</template>
				</el-table-column>
				<el-table-column prop="address" label="数据项" min-width="3%">
					<template slot-scope="scope">
						<div v-for='(item,i) in scope.row.columns' style="display: inline-block;">
							<span>{{item.code}}</span>
							<span v-if="i!=scope.row.columns.length-1">、</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="操作" min-width="1%">
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="projectClick(scope.row.id,scope.row)">编辑</a>
						<a class="editClass" @click.prevent="deleteClick('方案',scope.row.id,scope.row)">删除</a>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination" v-if="tableShow2">
				<el-pagination background @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total2" v-if="total2>20">
				</el-pagination>
			</div>
			<!--3-任务表格-->
			<el-table :data="taskList" style="width: 100%" v-show="tableShow3" class="tabPositionClass">
				<el-table-column prop="" label="任务ID" min-width="1%">
					<template slot-scope="scope">{{scope.row.task_id}}</template>
				</el-table-column>
				<el-table-column prop="" label="执行间隔" min-width="1%">
					<template slot-scope="scope">{{scope.row.step}}</template>
				</el-table-column>
				<!--<el-table-column prop="address" label="执行间隔" min-width="1%">
				</el-table-column>-->
				<el-table-column prop="" label="状态" min-width="1%">
					<template slot-scope="scope">{{scope.row.state|stateFilter}}</template>
				</el-table-column>
				<el-table-column prop="" label="开始时间" min-width="1%">
					<template slot-scope="scope">{{scope.row.start_time}}</template>
				</el-table-column>
				<el-table-column prop="" label="结束时间" min-width="1%">
					<template slot-scope="scope">{{scope.row.end_time}}</template>
				</el-table-column>
				<el-table-column prop="" label="方案编号" min-width="1%">
					<template slot-scope="scope">{{scope.row.case_no}}</template>
				</el-table-column>
				<el-table-column prop="" label="延时" min-width="1%">
					<template slot-scope="scope">{{scope.row.delay}}</template>
				</el-table-column>
				<el-table-column prop="address" label="操作" min-width="1%">
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="taskClick(scope.row.id,scope.row)">编辑</a>
						<a class="editClass" @click.prevent="deleteClick('任务',scope.row.id)">删除</a>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination" v-if="tableShow3">
				<el-pagination background @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total3" v-if="total3>20">
				</el-pagination>
			</div>
			<!--4-上报历史表格-->
			<el-table :data="historyList" style="width: 100%" v-show="tableShow4" class="tabPositionClass">
				<el-table-column prop="" label="上报时间" min-width="1%">
					<template slot-scope="scope">{{scope.row.create_time}}</template>
				</el-table-column>
				<el-table-column prop="" label="上报内容" min-width="2%">
					<template slot-scope="scope">{{scope.row.msg}}</template>
				</el-table-column>
				<el-table-column prop="" label="回复" min-width="2%">
					<template slot-scope="scope">
						<div v-for="item in scope.row.applyList">
							{{item.apply}}
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination" v-if="tableShow4">
				<el-pagination background @size-change="handleSizeChange4" @current-change="handleCurrentChange4" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total4" v-if="total4>20">
				</el-pagination>
			</div>
		</div>
		<!--弹窗1-录入网关-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form>
				<el-form-item label="阿里名称" label-width="25%">
					<el-input type="text" v-model="nameS" autocomplete="off" @change="nameSChange()"></el-input>
				</el-form-item>
				<el-form-item label="通讯地址" label-width="25%">
					<el-input type="text" v-model="codeS" autocomplete="off" @change="codeSChange('录入网关')"></el-input>
				</el-form-item>
				<el-form-item label="备注" label-width="25%">
					<el-input type="text" v-model="remark" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="gatewaySave()" class="confrim" type="primary">立即创建</el-button>
				<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
		<!--弹窗2-新增设备-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible2" :width="dialogWidth2" :close-on-click-modal="false">
			<div class="specil">
				<label for="">端口</label>
				<el-select v-model="port" placeholder="请选择">
					<el-option v-for="item in portList" :key="item.value" :label="item.name" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="specilInput">
				<label for="">电压变比</label>
				<input type="text" class="inputClass" v-model="rate_v" />
				<label style="margin-left: 20px;">电流变比</label>
				<input type="text" class="inputClass" v-model="rate_a" />
			</div>
			<hr />
			<div style="margin-top: 20px;">
				<div style="margin:0 0 12px 7px">
					<el-checkbox v-model="checkedAll3" @change="changeClick3()">全选/全不选</el-checkbox>
				</div>
				<div class="ergencyLi" v-for="item in equimentData">
					<el-checkbox v-model="item.selected" @change="checkedRadioChange3">{{item.addr}}</el-checkbox>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addGateSave()" class="confrim" type="primary">加入网关</el-button>
				<el-button @click="dialogFormVisible2=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
		<!--弹窗3-透传-->
		<div class="transDialog">
			<el-dialog :title="title" :visible.sync="dialogFormVisible3" :width="dialogWidth2" :close-on-click-modal="false">
				<!--<el-input type="textarea" autosize v-model="textarea1" class="textarea1">
				</el-input>-->
				<div class="textarea1">
					<el-table :data="readData" style="width: 100%" v-if="readData.length>0">
						<el-table-column prop="apply_time" label="上报时间" min-width="1%">
						</el-table-column>
						<el-table-column prop="apply" label="上报内容" min-width="2%">
						</el-table-column>
					</el-table>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-input type="textarea" autosize v-model="msg" class="textarea2">
					</el-input>
					<el-button @click="sendSave()" class="confrim1" type="primary">发送</el-button>
				</div>
			</el-dialog>
		</div>
		<!--弹窗4-扩展录入-->
		<div class="dialogFour">
			<el-dialog :title="title" :visible.sync="dialogFormVisible4" :width="dialogWidth4" :close-on-click-modal="false">
				<div class="checkAllBox2" v-if="!large">
					<el-checkbox v-model="checkedAll2" @change="checkedAllChange2()">全选</el-checkbox>
				</div>
				<div style="display: flex;">
					<div style="flex: 4;">
						<el-form>
							<!--<el-form-item label="名称" label-width="30%">
								<el-select v-model="nameFour" placeholder="请选择" style="width:100%">
									<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>-->
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="equipmentModelChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="设备型号" label-width="30%">
									<el-input type="text" v-model="equipmentModel" autocomplete="off"></el-input>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="category_idChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="监测设备类型" label-width="30%">
									<el-select v-model="category_id" placeholder="请选择" style="width:100%" @change="categoryChange()">
										<el-option v-for="item in categoryData" :key="item.id" :label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="product_idChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="监测设备型号" label-width="30%">
									<el-select v-model="product_id" placeholder="请选择" style="width:100%">
										<el-option v-for="item in projectData" :key="item.id" :label="item.model" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-form-item label="设备编号" label-width="30%" v-if="large">
									<span>{{equipmentCode}}</span>
									<!--<el-input type="text" v-model="equipmentCode" autocomplete="off" @change="codeSChange('扩展录入1')"></el-input>-->
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="rate_vFourChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="电压变比" label-width="30%">
									<el-input type="text" v-model="rate_vFour" autocomplete="off" @input="rate_vFour=rate_vFour.replace(/^(0+)|[^\d]+/g,'')"></el-input>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="rate_aFourChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="电流变比" label-width="30%">
									<el-input type="text" v-model="rate_aFour" autocomplete="off" @input="rate_aFour=rate_aFour.replace(/^(0+)|[^\d]+/g,'')"></el-input>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="addrFourChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="通讯地址" label-width="30%">
									<el-input type="text" v-model="addrFour" autocomplete="off" @change="codeSChange('扩展录入2')"></el-input>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="rate_typeChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="波特率" label-width="30%">
									<el-select v-model="rate_type" placeholder="请选择" style="width:100%">
										<el-option v-for="item in rate_typeList" :key="item.id" :label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</el-form>
					</div>
					<div style="flex: 1;"></div>
					<div style="flex: 4;">
						<el-form>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="ruler_typeChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="规约类型" label-width="30%">
									<el-select v-model="ruler_type" placeholder="请选择" style="width:100%">
										<el-option v-for="item in ruler_typeList" :key="item.id" :label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="portValueChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="端口" label-width="30%">
									<el-select v-model="portValue" placeholder="请选择" style="width:100%">
										<el-option v-for="item in portList" :key="item.value" :label="item.name" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="passwordChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="通信密码" label-width="30%">
									<el-input type="text" v-model="password" autocomplete="off"></el-input>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="fee_numChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="费率个数" label-width="30%">
									<el-input type="text" v-model="fee_num" autocomplete="off"></el-input>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="user_typeChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="用户类型" label-width="30%">
									<el-input type="text" v-model="user_type" autocomplete="off"></el-input>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="join_typeChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="接线方式" label-width="30%">
									<el-select v-model="join_type" placeholder="请选择" style="width:100%">
										<el-option v-for="item in join_typeList" :key="item.id" :label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="rated_vChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="额定电压" label-width="30%">
									<el-input type="text" v-model="rated_v" autocomplete="off"></el-input>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="rated_aChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="额定电流" label-width="30%">
									<el-input type="text" v-model="rated_a" autocomplete="off"></el-input>
								</el-form-item>
							</div>
							<div class="largeCheckBoxClass">
								<el-checkbox v-model="p_codeChecked" @change="checkedRadioChange2()" class='largeCheckClass' v-if="!large"></el-checkbox>
								<el-form-item label="资产号" label-width="30%">
									<el-input type="text" v-model="p_code" autocomplete="off"></el-input>
								</el-form-item>
							</div>
						</el-form>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="extendSave()" class="confrim" type="primary">立即创建</el-button>
					<el-button @click="dialogFormVisible4=false" class="cancle">取消</el-button>
				</div>
			</el-dialog>
			<!--弹窗5-任务新增-->
			<div class="dialogFour">
				<el-dialog :title="title" :visible.sync="dialogFormVisible5" :width="dialogWidth4" :close-on-click-modal="false">
					<div style="display: flex;">
						<div style="flex: 1;">
							<el-form>
								<el-form-item label="执行间隔" label-width="30%">
									<div style="display: inline-block;width:49%;">
										<el-input type="text" placeholder="时间" v-model="step" autocomplete="off"></el-input>
									</div>
									<div style="display: inline-block;width:49%;">
										<el-select v-model="step_type" placeholder="单位" style="width:100%">
											<el-option v-for="item in step_typeList" :key="item.id" :label="item.name" :value="item.id">
											</el-option>
										</el-select>
									</div>
								</el-form-item>
								<el-form-item label="任务ID" label-width="30%">
									<el-input type="text" placeholder="单行输入" v-model="task_id" autocomplete="off"></el-input>
								</el-form-item>
								<el-form-item label="方案编号" label-width="30%">
									<el-select v-model="plan_id" placeholder="请选择" style="width:100%">
										<el-option v-for="item in collectList" :key="item.id" :label="item.case_no" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="采集方案" label-width="30%">
									<el-select v-model="case_type" placeholder="请选择" style="width:100%">
										<el-option v-for="item in case_typeList" :key="item.id" :label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="开始时间" label-width="30%">
									<el-date-picker v-model="start_time" type="date" placeholder="yyyy-MM-dd hh:mm:ss" value-format="yyyy-MM-dd hh:mm:ss" suffix-icon="close" style="width:100%">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="结束时间" label-width="30%">
									<el-date-picker v-model="end_time" type="date" placeholder="yyyy-MM-dd hh:mm:ss" value-format="yyyy-MM-dd hh:mm:ss" suffix-icon="close" style="width:100%">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="延时" label-width="30%">
									<div style="display: inline-block;width:49%;">
										<el-input type="text" placeholder="时间" v-model="delay" autocomplete="off"></el-input>
									</div>
									<div style="display: inline-block;width:49%;">
										<el-select v-model="delay_type" placeholder="单位" style="width:100%">
											<el-option v-for="item in step_typeList" :key="item.id" :label="item.name" :value="item.id">
											</el-option>
										</el-select>
									</div>
								</el-form-item>
								<el-form-item label="任务运行时间段" label-width="30%"></el-form-item>
								<el-form-item label="类型" label-width="30%">
									<el-select v-model="time_type" placeholder="请选择" style="width:100%">
										<el-option v-for="item in time_typeList" :key="item.id" :label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<!--<el-form-item label="前时间" label-width="30%">
									<el-date-picker v-model="username" type="date" placeholder="yy-mm-dd" value-format="timestamp" suffix-icon="close" style="width:100%">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="后时间" label-width="30%">
									<el-date-picker v-model="username" type="date" placeholder="yy-mm-dd" value-format="timestamp" suffix-icon="close" style="width:100%">
									</el-date-picker>
								</el-form-item>-->
							</el-form>
						</div>
						<div style="flex: 1;">
							<el-form>
								<el-form-item label="执行优先等级" label-width="30%">
									<el-input type="text" v-model="priority" autocomplete="off" placeholder="单行输入"></el-input>
								</el-form-item>
								<el-form-item label="状态" label-width="30%">
									<el-radio v-model="state" label="正常">正常（1）</el-radio>
									<el-radio v-model="state" label="停用">停用（2）</el-radio>
								</el-form-item>
								<el-form-item label="任务开始前脚本id" label-width="30%">
									<el-input type="text" v-model="pre_id" autocomplete="off" placeholder="单行输入"></el-input>
								</el-form-item>
								<el-form-item label="任务开始后脚本id" label-width="30%">
									<el-input type="text" v-model="suf_id" autocomplete="off" placeholder="单行输入"></el-input>
								</el-form-item>
								<el-form-item label="" label-width="30%">

								</el-form-item>
								<el-form-item label="" label-width="30%">

								</el-form-item>
								<el-form-item label="" label-width="30%">

								</el-form-item>
								<el-form-item label="" label-width="30%">

								</el-form-item>
								<el-form-item label="时段" label-width="30%">

								</el-form-item>
								<el-form-item label="起始小时" label-width="30%">
									<el-input type="text" v-model="time_start_h" autocomplete="off" placeholder="单行输入"></el-input>
								</el-form-item>
								<el-form-item label="起始分钟" label-width="30%">
									<el-input type="text" v-model="time_start_m" autocomplete="off" placeholder="单行输入"></el-input>
								</el-form-item>
								<el-form-item label="结束小时" label-width="30%">
									<el-input type="text" v-model="time_end_h" autocomplete="off" placeholder="单行输入"></el-input>
								</el-form-item>
								<el-form-item label="结束分钟" label-width="30%">
									<el-input type="text" v-model="time_end_m" autocomplete="off" placeholder="单行输入"></el-input>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="taskSave()" class="confrim" type="primary">建立任务</el-button>
						<el-button @click="dialogFormVisible5=false" class="cancle">取消</el-button>
					</div>
				</el-dialog>
			</div>
			<!--弹窗6-方案新增-->
			<div class="dialogFour">
				<el-dialog :title="title" :visible.sync="dialogFormVisible6" :width="dialogWidth" :close-on-click-modal="false">
					<div style="display: flex;">
						<div style="flex: 2;">
							<el-form>
								<el-form-item label="采集方案" label-width="30%">
									<el-select v-model="case_type2" placeholder="请选择" style="width:100%">
										<el-option v-for="item in case_typeList" :key="item.id" :label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="方案编号" label-width="30%">
									<el-input type="number" placeholder="单行输入" v-model="case_no" autocomplete="off"></el-input>
								</el-form-item>
								<!--<el-form-item label="系统类型" label-width="30%">
									<el-select v-model="value" placeholder="请选择" style="width:100%">
										<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>-->
								<el-form-item label="存储深度" label-width="30%">
									<el-input type="text" placeholder="单行输入" v-model="store_depth" autocomplete="off"></el-input>
								</el-form-item>
								<el-form-item label="采集方式" label-width="30%">
									<el-select v-model="collect_type" placeholder="请选择" style="width:100%">
										<el-option v-for="item in collect_typeList" :key="item.id" :label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="采集内容" label-width="30%" v-if='collect_type==1||collect_type==5'>
									<el-input type="number" placeholder="单行输入" v-model="collect_content" autocomplete="off"></el-input>
								</el-form-item>
								<el-form-item label="ms数据类型分类" label-width="30%">
									<el-select v-model="ms" placeholder="请选择" style="width:100%">
										<el-option v-for="item in msList" :key="item.id" :label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<div v-for="(item,index) in userList" v-if='ms==2'>
									<el-form-item label="一组用户类型对应值" label-width="30%">
										<el-input type="number" placeholder="单行输入" v-model="item.oneVal" autocomplete="off" style="width:90%"></el-input>
										<el-button type="info" icon="el-icon-plus" circle @click="addClick()" v-if="index==0"></el-button>
										<el-button type="info" icon="el-icon-minus" circle @click="minusClick(index)" v-if="index!=0"></el-button>
									</el-form-item>
								</div>
								<el-form-item label="储存时标选择" label-width="30%">
									<el-select v-model="time_marker" placeholder="请选择" style="width:100%">
										<el-option v-for="item in time_markerList" :key="item.id" :label="item.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<!--TODO-->
								<el-form-item label="监测设备类型" label-width="30%">
									<el-select v-model="parser_id" placeholder="请选择" style="width:100%" @change="getParserItem(parser_id)">
										<el-option v-for="item in gatewayProductList" :key="item.parser_id" :label="item.model" :value="item.parser_id">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="记录列选择" label-width="30%">
									<el-button type="primary" plain @click="selectHandle()" style="margin-left:4px;padding:8px;font-size: 12px;" :disabled="!parser_id">记录列筛选</el-button>
									<div class="specilCheckBox">
										<div class="parserClass" v-for="item in parserItemList" v-if="item.checked==true">
											<el-checkbox v-model="item.checked" :disabled="!parser_id">{{item.name}}</el-checkbox>
											<div class="nameClass2">{{item.code}}</div>
										</div>
									</div>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="projectSave()" class="confrim" type="primary">建立方案</el-button>
						<el-button @click="dialogFormVisible6=false" class="cancle">取消</el-button>
					</div>
				</el-dialog>
			</div>
			<!--二级弹窗-->
			<el-dialog :title="title" :visible.sync="dialogFormVisible10" :width="dialogWidth2" :close-on-click-modal="false">
				<div>
					<div class="checkAllBox">
						<el-checkbox v-model="checkedAll" @change="checkedAllChange()">全选</el-checkbox>
					</div>
					<div :class="[item.selected?'parserClass2':'parserClass3']" v-for="item in parserItemList">
						<el-checkbox v-model="item.checked" @change="checkedRadioChange()">{{item.name}}</el-checkbox>
						<div :class="[item.selected?'nameClass33':'nameClass22']" v-if="item.selected==true">{{item.code}}</div>
						<div :class="[item.checked?'nameClass33':'nameClass22']" v-if="item.selected==false">{{item.code}}</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible10=false" class="confrim" type="primary">确认</el-button>
					<el-button @click="dialogFormVisible10=false" class="cancle">取消</el-button>
				</div>
			</el-dialog>
			<!--读取弹窗-->
			<el-dialog :title="title" :visible.sync="dialogFormVisible7" :width="dialogWidth4" :close-on-click-modal="false">
				<div>
					<el-table :data="readData" style="width: 100%">
						<el-table-column prop="apply_time" label="上报时间" min-width="1%">
						</el-table-column>
						<el-table-column prop="apply" label="上报内容" min-width="3%">
						</el-table-column>
						<el-table-column prop="" label="操作" min-width="1%">
							<template slot-scope="scope">
								<a class="editClass" @click.prevent="analysisClick(scope.row.command_log_id)">解析</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible7=false" class="confrim" type="primary">确认</el-button>
				</div>
			</el-dialog>
			<!--解析弹窗-->
			<el-dialog :title="title2" :visible.sync="dialogFormVisible8" :width="dialogWidth4" :close-on-click-modal="false">
				<div>
					<!--档案解析-->
					<el-table :data="analysisList" style="width: 100%" v-if="title2=='档案解析'">
						<el-table-column prop="archive_no" label="设备编号" width="130">
						</el-table-column>
						<el-table-column prop="tsa" label="通讯地址" width="130">
						</el-table-column>
						<el-table-column prop="user_type" label="用户类型" width="130">
						</el-table-column>
						<el-table-column prop="port" label="端口" width="130">
						</el-table-column>
						<el-table-column prop="rate_type" label="波特率" width="130">
						</el-table-column>
						<el-table-column prop="ruler_type" label="规约类型" width="130">
						</el-table-column>
						<el-table-column prop="rate_v" label="电压变比" width="130">
						</el-table-column>
						<el-table-column prop="rate_a" label="电流变比" width="130">
						</el-table-column>
						<el-table-column prop="password" label="通讯密码" width="130">
						</el-table-column>
						<el-table-column prop="fee_num" label="费率个数" width="130">
						</el-table-column>
						<el-table-column prop="join_type" label="接线方式" width="130">
						</el-table-column>
						<el-table-column prop="rated_v" label="额定电压" width="130">
						</el-table-column>
						<el-table-column prop="rated_a" label="额定电流" width="130">
						</el-table-column>
						<el-table-column prop="p_code" label="资产号" width="130">
						</el-table-column>
					</el-table>
					<!--方案解析-->
					<el-table :data="analysisList" style="width: 100%" v-if="title2=='方案解析'">
						<el-table-column prop="case_type" label="采集方案" min-width="1%">
						</el-table-column>
						<el-table-column prop="case_no" label="方案编号" min-width="1%">
						</el-table-column>
						<!--<el-table-column prop="" label="系统类型" min-width="1%">
						</el-table-column>-->
						<el-table-column prop="store_depth" label="存储深度" min-width="1%">
						</el-table-column>
						<el-table-column prop="collect_type" label="采集方式" min-width="1%">
						</el-table-column>
						<el-table-column prop="collect_content" label="采集内容" min-width="1%">
						</el-table-column>
						<el-table-column prop="ms" label="表计集合" min-width="1%">
						</el-table-column>
						<el-table-column prop="ms_user" label="表计内容" min-width="1%">
						</el-table-column>
						<el-table-column prop="time_marker" label="储存时标选择" min-width="1%">
						</el-table-column>
						<el-table-column prop="columns" label="记录选择" min-width="1%">
						</el-table-column>
					</el-table>
					<!--任务解析-->
					<el-table :data="analysisList" style="width: 100%" v-if="title2=='任务解析'">
						<el-table-column prop="task_id" label="任务id" width="130">
						</el-table-column>
						<el-table-column prop="case_no" label="方案编号" width="130">
						</el-table-column>
						<el-table-column prop="step" label="执行间隔" width="130">
						</el-table-column>
						<el-table-column prop="state" label="状态" width="130">
						</el-table-column>
						<el-table-column prop="case_type" label="方案类型" width="130">
						</el-table-column>
						<el-table-column prop="start_time" label="开始时间" width="130">
						</el-table-column>
						<el-table-column prop="end_time" label="结束时间" width="130">
						</el-table-column>
						<el-table-column prop="delay" label="延时" width="130">
						</el-table-column>
						<el-table-column prop="time_type" label="任务运行时段" width="130">
						</el-table-column>
						<el-table-column prop="pre_id" label="开始脚本ID" width="130">
						</el-table-column>
						<el-table-column prop="suf_id" label="完成脚本ID" width="130">
						</el-table-column>
						<el-table-column prop="time_end_h" label="起始小时" width="130">
						</el-table-column>
						<el-table-column prop="time_start_m" label="起始分钟" width="130">
						</el-table-column>
						<el-table-column prop="time_end_h" label="结束小时" width="130">
						</el-table-column>
						<el-table-column prop="time_end_m" label="结束分钟" width="130">
						</el-table-column>
						<el-table-column prop="priority" label="执行优先等级" width="130">
						</el-table-column>
					</el-table>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible8=false" class="confrim" type="primary">确认</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	/*自动生成价格分类列表*/
	function Sell(oneVal) {
		this.oneVal = oneVal;
	}
	Sell.prototype.setVar1 = function(value) {
		this.oneVal = value;
	};
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import md5 from '../../../static/js/md5.js'
	import timeConvert from '../../../static/js/timeyymmddmmss.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		//解决相同路由不刷新的问题
		watch: {
			$route(to, from) {
				//获取某个类距离顶部的距离
				var offset = $(".gateway").offset()
				//某个id的高度（注意：要是id）
				//var box1 =document.getElementById("home_headerB").offsetHeight
				this.clientHeight = document.body.clientHeight - offset['top']
				if(this.$route.query.id) {
					this.b_id = window.sessionStorage.getItem('b_id')
					this.gatewayId = this.$route.query.id
					this.getById(); //获取当前子项目列表
					this.getCmannger(); //c_manger列表
					this.getPath(); //获取面包屑导航路径

					this.getGateway(); //网关列表
					this.getCategory(); //分类列表
					this.categoryChange(); //分类的改变
					window.addEventListener('resize', () => {
						var offset = $(".gateway").offset()
						//某个id的高度（注意：要是id）
						//var box1 =document.getElementById("home_headerB").offsetHeight
						this.clientHeight = document.body.clientHeight - offset['top']
						if(document.body.clientWidth < 767) {
							this.dialogWidth = "100%"
							this.dialogWidth2 = "100%"
							this.dialogWidth4 = "100%"
						} else if(document.body.clientWidth < 1200) {
							this.dialogWidth = "64%"
							this.dialogWidth2 = "80%"
							this.dialogWidth4 = "80%"
						} else {
							this.dialogWidth = "32%"
							this.dialogWidth2 = "50%"
							this.dialogWidth4 = "70%"
						}
					})
				}
			}
		},
		mounted() {
			//获取某个类距离顶部的距离
			var offset = $(".gateway").offset()
			//某个id的高度（注意：要是id）
			//var box1 =document.getElementById("home_headerB").offsetHeight
			this.clientHeight = document.body.clientHeight - offset['top']
			this.userList.push(new Sell());
			this.b_id = window.sessionStorage.getItem('b_id')
			this.gatewayId = this.$route.query.id
			this.getById(); //获取当前子项目列表
			this.getCmannger(); //c_manger列表
			this.getPath(); //获取面包屑导航路径
			this.getGateway(); //网关列表
			this.getCategory(); //分类列表
			this.categoryChange(); //分类的改变
			window.addEventListener('resize', () => {
				var offset = $(".gateway").offset()
				//某个id的高度（注意：要是id）
				//var box1 =document.getElementById("home_headerB").offsetHeight
				this.clientHeight = document.body.clientHeight - offset['top']
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
					this.dialogWidth2 = "100%"
					this.dialogWidth4 = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
					this.dialogWidth2 = "80%"
					this.dialogWidth4 = "80%"
				} else {
					this.dialogWidth = "32%"
					this.dialogWidth2 = "50%"
					this.dialogWidth4 = "70%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
				this.dialogWidth2 = "100%"
				this.dialogWidth4 = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
				this.dialogWidth2 = "80%"
				this.dialogWidth4 = "80%"
			} else {
				this.dialogWidth = "34%"
				this.dialogWidth2 = "50%"
				this.dialogWidth4 = "70%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				clientHeight: '', //滚动高度
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				pageIndex2: 1, //当前页
				total1: 0, //总条数
				total2: 0, //总条数
				total3: 0, //总条数
				total4: 0, //总条数
				tableData: [],
				readData: [], //读取列表
				log_Id: '', //读取id
				dialogFormVisible: false, //录入网关
				dialogFormVisible2: false, //新增设备
				dialogFormVisible3: false, //透传
				dialogFormVisible4: false, //新增录入
				dialogFormVisible5: false, //任务
				dialogFormVisible6: false, //方案
				dialogFormVisible7: false, //读取弹窗
				dialogFormVisible8: false, //解析弹窗
				dialogFormVisible10: false, //二级弹窗
				title: '', //弹窗标题
				/*表单*/
				username: '', //用户名
				dialogWidth: '32%', //dialog的宽度
				dialogWidth2: '50%', //dialog的宽度
				dialogWidth4: '70%', //dialog的宽度
				editId: null, //编辑的id
				notDo: false, //不执行开关
				listRow: {}, //编辑行数据
				value: 1,
				tabPosition: '设备', //tab默认选项
				tableShow1: true, //表格的展示
				tableShow2: false,
				tableShow3: false,
				tableShow4: false,
				checked: true,
				textarea1: '', //透传textarea
				msg: '', //透传textarea
				radio: '1',
				gatewayId: '', //网关id
				rowObj: {}, //网关对象列表
				/*基础信息*/
				boxShow: false, //是否显示
				urlValue: '', //面包屑
				createTime: '', //创建时间
				nameValue: '', //创建人
				equimentName: '', //设备名称
				equimentCode: '', //设备编号
				remarkValue: '', //备注
				addr: '', //地址
				gateway_id: '', //网关id
				uid_Sign: '', //网关录入uid的更新
				/*表单1---网关*/
				category_idChild: '', //分类id
				product_idChild: '', //产品id
				nameS: '', //设备名称
				codeS: '', //设备编号
				remark: '', //备注
				/*表单2---新增设备*/
				checkedAll3: false, //全选
				checkedAll2: false, //全选
				/*左*/
				equipmentModelChecked: false,
				category_idChecked: false,
				product_idChecked: false,
				rate_vFourChecked: false,
				rate_aFourChecked: false,
				addrFourChecked: false,
				rate_typeChecked: false,
				/*右*/
				ruler_typeChecked: false,
				portValueChecked: false,
				passwordChecked: false,
				fee_numChecked: false,
				user_typeChecked: false,
				join_typeChecked: false,
				rated_vChecked: false,
				rated_aChecked: false,
				p_codeChecked: false,
				large: false, //设备展示开关
				multipleSelection: [], //选中列表
				port: '', //端口
				portList: [{
						name: 'F2010201:4851',
						value: 'F2010201'
					},
					{
						name: 'F2010202:4852',
						value: 'F2010202'
					},
					{
						name: 'F20B0201:蓝牙',
						value: 'F20B0201'
					},
					{
						name: 'F2090201:载波/微功率无线接口',
						value: 'F2090201'
					},
				],
				rate_v: '1', //电压变比
				rate_a: '1', //电流变比
				addrData: [], //通讯地址列表
				analysisVal: '', //解析标识
				title2: '', //解析弹窗标题
				/*表单4-扩展录入*/
				rowSubproject: {}, //子项目列表
				rowSeting: {}, //
				edit_id: '', //编辑的id
				equimentData: [], //未关联的设备列表
				categoryData: [], //分类列表
				projectData: [], //产品列表
				nameFour: '', //名称
				equipmentModel: '', //设备型号
				category_id: '', //监测设备类型
				product_id: '', //监测设备型号
				equipmentCode: '', //设备编号
				rate_vFour: '', //电压变比
				rate_aFour: '', //电流变比
				addrFour: '', //通讯地址
				fee_num: '', //费率个数
				user_type: '', //用户类型
				rated_v: '', //额定电压 
				rated_a: '', //额定电流
				p_code: '000000000000', //资产号
				password: '', //通信密码
				portValue: '', //端口
				join_type: '', //接线方式
				join_typeList: [{
						id: 0,
						name: '未知（0）'
					},
					{
						id: 1,
						name: '单相（1）'
					},
					{
						id: 2,
						name: '三相三线（2）'
					},
					{
						id: 3,
						name: '三相四线（3）'
					},
				], //接线方式列表
				rate_type: '', //波特率
				rate_typeList: [{
						id: 255,
						name: '自适应（偶校验）'
					},
					{
						id: 0,
						name: '300bps（偶校验）'
					},
					{
						id: 1,
						name: '600bps（偶校验）'
					},
					{
						id: 2,
						name: '1200bps（偶校验）'
					},
					{
						id: 3,
						name: '2400bps（偶校验）'
					},
					{
						id: 4,
						name: '4800bps（偶校验）'
					},
					{
						id: 5,
						name: '7200bps（偶校验）'
					},
					{
						id: 6,
						name: '9600bps（偶校验）'
					},
					{
						id: 7,
						name: '19200bps（偶校验）'
					},
					{
						id: 8,
						name: '38400bps（偶校验）'
					},
					{
						id: 9,
						name: '57600bps（偶校验）'
					},
					{
						id: 10,
						name: '115200bps（偶校验）'
					},
					{
						id: 128,
						name: '300bps（无校验）'
					},
					{
						id: 129,
						name: '600bps（无校验）'
					},
					{
						id: 130,
						name: '1200bps（无校验）'
					},
					{
						id: 131,
						name: '2400bps（无校验）'
					},
					{
						id: 132,
						name: '4800bps（无校验）'
					},
					{
						id: 133,
						name: '7200bps（无校验）'
					},
					{
						id: 134,
						name: '9600bps（无校验）'
					},
					{
						id: 135,
						name: '19200bps（无校验）'
					},
					{
						id: 136,
						name: '38400bps（无校验）'
					},
					{
						id: 137,
						name: '57600bps（无校验）'
					},
					{
						id: 138,
						name: '115200bps（无校验）'
					}
				], //波特率列表
				ruler_type: '', //规约类型
				ruler_typeList: [{
						id: 0,
						name: '未知（0）'
					},
					{
						id: 1,
						name: 'DL/T 645-1997（1）'
					},
					{
						id: 2,
						name: 'DL/T 645—2007（2）'
					},
					{
						id: 3,
						name: 'DL/T 698.45（3）'
					},
					{
						id: 4,
						name: 'CJ/T 188—2004（4）'
					},
					{
						id: 5,
						name: 'ModBus（5）'
					},
				], //规约类型列表
				/*表单6--方案*/
				gatewayProductList: [], //获取监测设备类型列表
				collectList: [], //方案列表
				project_Id: '', //方案id
				case_type2: '', //采集方案
				case_no: '', //方案编号
				store_depth: '', //存储深度
				collect_type: '', //采集类型
				collect_content: null,
				collect_typeList: [{
						name: '当前数据（0）',
						id: 0
					},
					{
						name: '冻结数据（1）',
						id: 1
					},
					{
						name: 'modbus功能码（5）',
						id: 5
					},
				], //采集类型列表
				ms: '', //MS数据类型
				msList: [{
						id: 1,
						name: '全部用户地址（1）'
					},
					{
						id: 2,
						name: ' 一组用户类型（2）'
					}
				], //MS数据类型列表
				userList: [], //一组用户列表
				time_marker: '', //存储时标
				time_markerList: [{
						id: 0,
						name: '未定义（0）'
					}, {
						id: 1,
						name: '任务开始时间（1）'
					},
					{
						id: 2,
						name: '相对当日0点0分（2）'
					},
					{
						id: 3,
						name: '相对上日23点59分（3）'
					},
					{
						id: 4,
						name: '相对上日0点0分（4）'
					},
					{
						id: 5,
						name: '相对当月1日0点0分（5）'
					},
					{
						id: 6,
						name: '数据冻结时标（6）'
					},
					{
						id: 7,
						name: '相对上月月末23点59分（7）'
					},
				], //存储时标列表
				product_idN: '', //产品id
				parser_id: '', //所属抄读设置的id
				parser_idbackUp: '', //所属抄读设置的id（老数据）
				parserItemList: [], //抄读项列表
				checkedAll: false, //全选
				plan_idN: '', //当前方案的id
				/*表单5--任务*/
				taskList: [], //任务列表
				task_Id: '', //任务编辑的id
				setingList: [], //设置列表
				plan_id: '', //所属方案
				task_id: '', //任务ID
				step_type: 1, //时间间隔单位
				step_typeList: [{
						name: '秒（0）',
						id: 0
					},
					{
						name: '分（1）',
						id: 1
					},
					{
						name: '时（2）',
						id: 2
					},
					{
						name: '日（3）',
						id: 3
					},
					{
						name: '月（4）',
						id: 4
					},
					{
						name: '年（5）',
						id: 5
					},
				],
				step: '30', //时间间隔数值
				case_type: 1, //方案类型
				case_typeList: [{
						name: '普通采集方案（1）',
						id: 1
					},
					{
						name: '事件采集方案（2）',
						id: 2
					},
					{
						name: '透明方案（3）',
						id: 3
					},
					{
						name: '上报方案（4）',
						id: 4
					},
					{
						name: '脚本方案（5）',
						id: 5
					},
				], //方案列表
				start_time: '', //开始时间
				end_time: '', //结束时间
				delay: '', //延时间隔数值
				delay_type: '', //延时间隔单位
				priority: '', //执行优先级
				state: '正常', //任务状态
				pre_id: '', //任务开始前脚本ID
				suf_id: '', //任务完成后脚本ID
				time_type: '', //任务运行时段类型
				time_typeList: [{
					name: '前闭后开（0）',
					id: 0,
				}, {
					name: '前开后闭（1）',
					id: 1,
				}, {
					name: '前闭后闭（2）',
					id: 2,
				}, {
					name: '前开后开（3）',
					id: 3,
				}],
				time_start_h: '', //起始小时
				time_start_m: '', //起始分钟
				time_end_h: '', //结束小时
				time_end_m: '', //结束分钟
				isset: '', //是否已下发
				set_time: '', //最近一次下发时间
				/*上报历史*/
				historyList: [], //上报历史列表
				use_status: '', //网关离在线
				hei: '', //网关Mei
				imsi: '', //网关imsi
				iccid: '', //网关iccid
				/*解析*/
				analysisList: [], //解析列表
				b_id: '', //b_id
			}
		},
		filters: {
			stateFilter: function(val) {
				if(val == "1") {
					return "正常";
				}
				if(val == "2") {
					return "停用";
				}
			},
			collect_typeFilter: function(val) {
				if(val == "0") {
					return "当前数据";
				}
				if(val == "1") {
					return "冻结数据";
				}
				if(val == "5") {
					return "modbus功能码";
				}
			},
			time_typeFilter: function(val) {
				if(val == "0") {
					return "前闭后开";
				}
				if(val == "1") {
					return "前开后闭";
				}
				if(val == "2") {
					return "前闭后闭";
				}
				if(val == "3") {
					return "前开后开";
				}
			},
			case_typeFilter: function(val) {
				if(val == "1") {
					return "普通采集方案";
				}
				if(val == "2") {
					return "事件采集方案";
				}
				if(val == "3") {
					return "透明方案";
				}
				if(val == "4") {
					return "上报方案";
				}
				if(val == "5") {
					return "脚本方案";
				}
			},
			portFilter: function(val) {
				if(val == "F2010201") {
					return "F2010201:4851";
				}
				if(val == "F2010202") {
					return "F2010202:4852";
				}
				if(val == "F20B0201") {
					return "F20B0201:蓝牙";
				}
				if(val == "F2090201") {
					return "F2090201:载波/微功率无线接口";
				}
			},
			rate_typeFilter: function(val) {
				if(val == "255") {
					return "自适应偶校验";
				}
				if(val == "0") {
					return "300bps偶校验";
				}
				if(val == "1") {
					return "600bps偶校验";
				}
				if(val == "2") {
					return "1200bps偶校验";
				}
				if(val == "3") {
					return "2400bps偶校验";
				}
				if(val == "4") {
					return "4800bps偶校验";
				}
				if(val == "5") {
					return "7200bps偶校验";
				}
				if(val == "6") {
					return "9600bps偶校验";
				}
				if(val == "7") {
					return "19200bps偶校验";
				}
				if(val == "8") {
					return "38400bps偶校验";
				}
				if(val == "9") {
					return "57600bps偶校验";
				}
				if(val == "10") {
					return "115200bps偶校验";
				}
				if(val == "128") {
					return "300bsp无校验";
				}
				if(val == "129") {
					return "600bsp无校验";
				}
				if(val == "130") {
					return "1200bsp无校验";
				}
				if(val == "131") {
					return "2400bsp无校验";
				}
				if(val == "132") {
					return "4800bsp无校验";
				}
				if(val == "133") {
					return "7200bsp无校验";
				}
				if(val == "134") {
					return "9600bsp无校验";
				}
				if(val == "135") {
					return "19200bsp无校验";
				}
				if(val == "136") {
					return "38400bsp无校验";
				}
				if(val == "137") {
					return "57600bsp无校验";
				}
				if(val == "138") {
					return "115200bsp无校验";
				}
			},
			ruler_typeFilter: function(val) {
				if(val == "0") {
					return "未知：0";
				}
				if(val == "1") {
					return "DL/T 645-1997：1";
				}
				if(val == "2") {
					return "DL/T 645—2007：2";
				}
				if(val == "3") {
					return "DL/T 698.45：3";
				}
				if(val == "4") {
					return "CJ/T 188—2004：4";
				}
				if(val == "5") {
					return "ModBus：5";
				}
			},
			join_typeFilter: function(val) {
				if(val == "0") {
					return "未知：0";
				}
				if(val == "1") {
					return "单相：1";
				}
				if(val == "2") {
					return "三相三线：2";
				}
				if(val == "3") {
					return "三相四线：3";
				}
			},
		},
		methods: {
			//添加
			addClick() {
				this.userList.push(new Sell());
			},
			//删除
			minusClick(index) {
				this.userList.splice(index, 1);
			},
			//每页多少
			handleSizeChange1(val) {
				this.pageSize = val;
				this.getSetingList();
			},
			//更改页数
			handleCurrentChange1(val) {
				this.pageIndex2 = val;
				this.getSetingList();
			},
			//每页多少
			handleSizeChange2(val) {
				this.pageSize = val;
				this.getCollectList();
			},
			//更改页数
			handleCurrentChange2(val) {
				this.pageIndex = val;
				this.getCollectList();
			},
			//每页多少
			handleSizeChange3(val) {
				this.pageSize = val;
				this.getTaskList();
			},
			//更改页数
			handleCurrentChange3(val) {
				this.pageIndex = val;
				this.getTaskList();
			},
			//每页多少
			handleSizeChange4(val) {
				this.pageSize = val;
				this.getHistoryList();
			},
			//更改页数
			handleCurrentChange4(val) {
				this.pageIndex = val;
				this.getHistoryList();
			},
			//获取当前子项目列表
			getById() {
				var params = {}
				let config = headers.headers(this.gatewayId)
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/subproject/' + this.gatewayId, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.rowObj = res.data
						this.deviceList(); //设备列表（未关联的列表）
						this.product_idN = res.data.product_id
						this.product_idChild = res.data.product_id
						this.category_idChild = res.data.category_id
						if(this.product_idN) {
							this.getParserId();
						}
					} else {
						this.rowObj = {}
						this.product_idN = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取所属抄读方式
			getParserId() {
				var params = {}
				let config = headers.headers(this.product_idN)
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product/' + this.product_idN, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.parser_idbackUp = res.data.parser_id
					} else {
						this.parser_idbackUp = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取抄读项列表
			getParserItem(parser_id) {
				var params = {
					pageSize: -1,
					pageIndex: 1,
					parser_id: parser_id,
				}
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(parser_id) {
					axios.get(this.http + '/zkep2/parser_item/getListByLimit', {
						params,
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data) {
							res.data.forEach(item => {
								item.selected = false
								item.checked = false
							})
							this.parserItemList = res.data
						} else {
							this.parserItemList = []
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.parserItemList = []
				}
			},
			//获取监测设备类型
			getGatewayProduct() {
				var params = {
					id: this.gateway_id,
				}
				let config = headers.headers('getGatewayProduct')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/gateway/getGatewayProduct', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.gatewayProductList = res.data
					} else {
						this.gatewayProductList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取分类列表
			getCategory() {
				var params = {
					pageSize: -1,
					pageIndex: 1,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.categoryData = res.data
					} else {
						this.categoryData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//设备列表（未关联的列表）
			deviceList() {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					gateway_id: 0,
					c_id: this.rowObj.c_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/device/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							item.selected = false
						})
						this.equimentData = res.data
					} else {
						this.equimentData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取面包屑导航路径
			getPath() {
				var params = {
					id: this.gatewayId
				}
				let config = headers.headers('getPath')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/subproject/getPath', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.urlValue = res.data
					} else {
						this.urlValue = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取c端manger用户名
			getCmannger() {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/c_manager/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							if(item.id == this.rowObj.c_manager_id) {
								this.createTime = item.create_time
								this.nameValue = item.username
							}
						})
					} else {
						this.nameValue = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//关联监测设备
			relationClick() {

			},
			//透传
			transClick() {
				this.title = "透传"
				this.dialogFormVisible3 = true
				this.readData = []
				this.msg = ''
			},
			//透传发送
			sendSave() {
				this.msg = this.msg.replace(/\s*/g, ""); //去除空格
				var manager_id = window.sessionStorage.getItem('id')
				var config = headers.headers('sendCommand')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					gateway_id: this.gateway_id,
					msg: this.msg,
				}
				//console.log(params)
				if(this.msg) {
					this.openFullScreen();
					axios.post(this.http + '/zkep2/gateway/sendCommand', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						this.loadingAdd.close();
						if(res.data.res == 1) {
							this.log_Id = res.data.id
							this.getReadList();
							this.$message({
								type: 'success',
								message: '透传发送成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: res.data.msg + '!'
							});
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$message('请输入完整报文！')
				}
			},
			//校时
			timingClick() {
				this.openFullScreen();
				let config = headers.headers('checkTime')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var manager_id = window.sessionStorage.getItem('id')
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					gateway_id: this.gateway_id
				}
				this.$confirm("确认对 “" + this.rowObj.name + "”的校时吗？", '确认要校时吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					axios.post(this.http + '/zkep2/gateway/checkTime', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						this.loadingAdd.close();
						//console.log(res)
						if(res.data.id) {
							this.$message({
								type: 'success',
								message: '校时成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: res.data.msg + '!'
							});
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消校时!'
					});
				});
			},
			//加载的动画
			openFullScreen() {
				this.loadingAdd = this.$loading({
					lock: true,
					text: '',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0)'
				});
			},
			//读取档案
			readFileClick() {
				this.openFullScreen();
				var manager_id = window.sessionStorage.getItem('id')
				var config = headers.headers('readArchives')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					id: this.gateway_id
				}
				//console.log(params)
				axios.post(this.http + '/zkep2/gateway/readArchives', qs.stringify(params), {
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					this.loadingAdd.close();
					if(res.data.res == 1) {
						this.title = "读取档案列表"
						this.dialogFormVisible7 = true
						this.log_Id = res.data.id
						this.getReadList('档案解析');
						this.$message({
							type: 'success',
							message: '读取档案成功!'
						});
					} else {
						this.$message({
							type: 'error',
							message: res.data.msg + '!'
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//读取列表
			getReadList(val) {
				this.analysisVal = val
				var params = {
					pageSize: -1,
					pageIndex: 1,
					command_log_id: this.log_Id
				}
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp

				axios.get(this.http + '/zkep2/command_apply/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.readData = res.data
					} else {
						this.readData = []
					}
				}).catch(err => {
					console.log(err)
				})

			},
			//解析
			analysisClick(command_id) {
				this.dialogFormVisible8 = true
				var url;
				if(this.analysisVal == '档案解析') {
					this.title2 = '档案解析'
					var config = headers.headers('parseArchivesResp')
					url = "/zkep2/gateway/parseArchivesResp"
				} else if(this.analysisVal == '方案解析') {
					var config = headers.headers('parseCollectResp')
					url = "/zkep2/gateway/parseCollectResp"
					this.title2 = '方案解析'
				} else if(this.analysisVal == '任务解析') {
					var config = headers.headers('parseTaskResp')
					url = "/zkep2/gateway/parseTaskResp"
					this.title2 = '任务解析'
				}
				var params = {
					command_id: command_id
				}
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + url, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.res == 1) {
						this.analysisList = res.data.dataRes
					} else {
						this.analysisList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//读取方案
			readCollectClick() {
				this.openFullScreen();
				var manager_id = window.sessionStorage.getItem('id')
				var config = headers.headers('readCollect')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					id: this.gateway_id
				}
				axios.post(this.http + '/zkep2/gateway/readCollect', qs.stringify(params), {
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loadingAdd.close();
					//console.log(res)
					if(res.data.id) {
						this.title = "读取方案列表"
						this.dialogFormVisible7 = true
						this.log_Id = res.data.id
						this.getReadList('方案解析');
						this.$message({
							type: 'success',
							message: '读取方案成功!'
						});
					} else {
						this.$message({
							type: 'error',
							message: '方案读取失败!'
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//读取任务
			readTaskClick() {
				this.openFullScreen();
				var manager_id = window.sessionStorage.getItem('id')
				var config = headers.headers('readTask')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					id: this.gateway_id
				}
				axios.post(this.http + '/zkep2/gateway/readTask', qs.stringify(params), {
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loadingAdd.close();
					//console.log(res)
					if(res.data.id) {
						this.title = "读取任务列表"
						this.dialogFormVisible7 = true
						this.log_Id = res.data.id
						this.getReadList('任务解析');
						this.$message({
							type: 'success',
							message: '读取任务成功!'
						});
					} else {
						this.$message({
							type: 'error',
							message: '任务读取失败!'
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//清空档案
			kongFileClick() {
				var manager_id = window.sessionStorage.getItem('id')
				var config = headers.headers('cleanArchives')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					id: this.gateway_id
				}
				this.$confirm("确认清空网关 “" + this.rowObj.name + "”的档案吗？", '确认要清空档案吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					axios.post(this.http + '/zkep2/gateway/cleanArchives', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {

							this.$message({
								type: 'success',
								message: '档案清空成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '档案清空失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消清空档案!'
					});
				});
			},
			//清空方案
			kongCollectClick() {
				var manager_id = window.sessionStorage.getItem('id')
				var config = headers.headers('cleanCollect')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					id: this.gateway_id
				}
				this.$confirm("确认清空网关 “" + this.rowObj.name + "”的方案吗？", '确认要清空方案吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					axios.post(this.http + '/zkep2/gateway/cleanCollect', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {

							this.$message({
								type: 'success',
								message: '方案清空成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '方案清空失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消清空方案!'
					});
				});
			},
			//清空任务
			kongTaskClick() {
				var manager_id = window.sessionStorage.getItem('id')
				var config = headers.headers('cleanTask')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					id: this.gateway_id
				}
				this.$confirm("确认清空网关 “" + this.rowObj.name + "”的任务吗？", '确认要清空任务吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					axios.post(this.http + '/zkep2/gateway/cleanTask', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {

							this.$message({
								type: 'success',
								message: '任务清空成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '任务清空失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消清空任务!'
					});
				});
			},
			//下发档案
			sendFileClick() {
				this.openFullScreen();
				var manager_id = window.sessionStorage.getItem('id')
				var config = headers.headers('addArchives')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					id: this.gateway_id,
					c_manager_id: this.rowObj.c_id
				}
				this.$confirm("确认下发网关 “" + this.rowObj.name + "”的档案吗？", '确认要下发档案吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					axios.post(this.http + '/zkep2/gateway/addArchives', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						this.loadingAdd.close();
						//console.log(res)
						if(res.data.res == 1) {
							this.$message({
								type: 'success',
								message: '档案下发成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: res.data.msg + '!'
							});
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
					this.loadingAdd.close();
					this.$message({
						type: 'info',
						message: '已取消下发档案!'
					});
				});
			},
			//下装方案
			sendCollectClick() {
				this.openFullScreen();
				var manager_id = window.sessionStorage.getItem('id')
				var config = headers.headers('addCollect')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					id: this.gateway_id
				}
				this.$confirm("确认下装网关 “" + this.rowObj.name + "”的方案吗？", '确认要下装方案吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					axios.post(this.http + '/zkep2/gateway/addCollect', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						this.loadingAdd.close();
						//console.log(res)
						if(res.data.res == 1) {
							this.$message({
								type: 'success',
								message: '方案下装成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: res.data.msg + '!'
							});
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
					this.loadingAdd.close();
					this.$message({
						type: 'info',
						message: '已取消下装方案!'
					});
				});
			},
			//下发任务
			sendTaskClick() {
				this.openFullScreen();
				var manager_id = window.sessionStorage.getItem('id')
				var config = headers.headers('addTask')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					src: 3,
					b_manager_id: this.b_id,
					id: this.gateway_id
				}
				this.$confirm("确认下发网关 “" + this.rowObj.name + "”的任务吗？", '确认要下发任务吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					axios.post(this.http + '/zkep2/gateway/addTask', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						this.loadingAdd.close();
						//console.log(res)
						if(res.data.res == 1) {
							this.$message({
								type: 'success',
								message: '任务下发成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: res.data.msg + '!'
							});
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
					this.loadingAdd.close();
					this.$message({
						type: 'info',
						message: '已取消下发任务!'
					});
				});
			},
			//tab的点击
			tabClick(val) {
				if(val == '设备') {
					this.tableShow1 = true;
					this.tableShow2 = false;
					this.tableShow3 = false;
					this.tableShow4 = false;
				} else if(val == '方案') {
					this.tableShow1 = false;
					this.tableShow2 = true;
					this.tableShow3 = false;
					this.tableShow4 = false;
				} else if(val == '任务') {
					this.tableShow1 = false;
					this.tableShow2 = false;
					this.tableShow3 = true;
					this.tableShow4 = false;
				} else if(val == '上报历史') {
					this.getHistoryList();
					this.tableShow1 = false;
					this.tableShow2 = false;
					this.tableShow3 = false;
					this.tableShow4 = true;
				}
			},
			/*
			 * 网关
			 * */
			//网关列表
			getGateway() {
				var params = {
					subproject_id: this.gatewayId
				}
				//console.log(params)
				let config = headers.headers('getBySubproject')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/gateway/getBySubproject', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.boxShow = true
						this.equimentName = res.data.name //设备名称
						if(res.data.code.slice(0, 1) != '-') {
							this.equimentCode = res.data.code //设备编号
						} else {
							this.equimentCode = '' //设备编号
						}
						this.remarkValue = res.data.remark //备注
						this.addr = res.data.addr //地址
						this.gateway_id = res.data.id //网关id
						this.use_status = res.data.use_status
						this.hei = res.data.hei
						this.imsi = res.data.imsi
						this.iccid = res.data.iccid
						this.getSetingList(); //设置列表
						this.getCollectList(); //方案列表
						this.getTaskList(); //任务列表
						this.getHistoryList(); //上报历史
						this.getGatewayProduct(); //获取监测设备类型
					} else {
						this.boxShow = false
						this.equimentName = '' //设备名称
						this.equimentCode = '' //设备编号
						this.remarkValue = '' //备注
						this.addr = '' //地址
						this.gateway_id = ''
						this.use_status = ''
						this.hei = ''
						this.imsi = ''
						this.iccid = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//录入网关
			ebtryGatewayClick(val) {
				this.uid_Sign = val
				this.dialogFormVisible = true
				if(val == '编辑网关') {
					this.title = "编辑网关"
				} else if(val == '录入网关') {
					this.title = "录入网关"
				}
				if(this.boxShow) { //编辑
					this.nameS = this.equimentName //设备名称
					this.codeS = this.addr //设备编号
					this.remark = this.remarkValue //备注
					this.category_idChild = this.rowObj.category_id
					this.product_idChild = this.rowObj.product_id
				} else { //添加
					this.nameS = '' //设备名称
					this.codeS = '' //设备编号
					this.remark = '' //备注
					this.product_idChild = ''
					this.category_idChild = ''
				}
			},
			//录入网关的保存
			gatewaySave() {
				this.childSave();
				this.finalSave();
			},
			//子项目更新保存
			childSave() {
				if(this.uid_Sign == '编辑网关') {
					var params = { //更新
						id: this.rowObj.id,
						product_id: this.product_idChild,
						category_id: this.category_idChild,
						status: 1,
						version: 0,
					}
				} else if(this.uid_Sign == '录入网关') {
					var params = { //更新
						id: this.rowObj.id,
						code: this.$uuid.v1(),
						product_id: this.product_idChild,
						category_id: this.category_idChild,
						status: 1,
						version: 0,
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(!this.notDo) {
					axios.post(this.http + '/zkep2/subproject/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							//this.dialogFormVisible = false
							this.getById();
						} else {
							this.$message('操作失败！')
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//网关的保存
			finalSave() {
				/*创建时间的处理*/
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				if(this.boxShow) { //编辑
					var params = {
						id: this.gateway_id,
						c_id: this.rowObj.c_id, //所属C端客户
						subproject_id: this.gatewayId, //所关联子项目
						product_name: '', //产品名称，随便填
						name: this.nameS,
						remark: this.remark,
						addr: this.codeS,
						task_step: 5,
						use_status: 0,
						iswait: 0,
						send_time: 0,
						status: 1,
						version: 0
					}
				} else {
					var params = {
						src: 3,
						b_manager_id: this.b_id,
						c_id: this.rowObj.c_id, //所属C端客户
						subproject_id: this.gatewayId, //所关联子项目
						product_name: '', //产品名称，随便填
						name: this.nameS,
						remark: this.remark,
						addr: this.codeS,
						task_step: 5,
						use_status: 0,
						iswait: 0,
						send_time: 0,
						create_time: timestamp,
						status: 1,
						version: 0
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(!this.notDo) {
					if(this.codeS && this.nameS) {
						axios.post(this.http + '/zkep2/gateway/save',
							qs.stringify(params), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
							//console.log(res)
							if(res.data.id) {
								this.boxShow = true
								this.dialogFormVisible = false
								this.getGateway();
							} else {
								this.$message('新增失败！');
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						this.$message('请输入必填项！');
					}
				}
			},
			//设备名称的更改(唯一值判断)
			nameSChange() {
				//				let config = headers.headers('save')
				//				var pass_token = config.pass_token
				//				var timestamp = config.timestamp
				//				var params = {
				//					id: 84,
				//					name: '010000000626'+'_'+'84',
				//					status:0
				//				}
				//				axios.post(this.http + '/zkep2/gateway/save',
				//					qs.stringify(params), {
				//						headers: {
				//							'pass-token': pass_token,
				//							'time': timestamp
				//						}
				//					}).then(res => {
				//					//console.log(res)
				//					if(res.data.id) {
				//						this.boxShow = true
				//						this.dialogFormVisible = false
				//						this.getGateway();
				//					} else {
				//						this.$message('新增失败！');
				//					}
				//				}).catch(err => {
				//					console.log(err)
				//				})
				var params = {
					name: this.nameS
				}
				let config = headers.headers('getByName')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/gateway/getByName', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						if(this.boxShow && this.nameS == this.equimentName) {
							this.notDo = false
							return
						}
						this.notDo = true
						this.$message('该设备名称已存在,请重新输入设备名称！');
						this.nameS = ''
					} else {
						this.notDo = false
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//设备编号的更改(唯一值判断)
			codeSChange(val) {
				if(val == '录入网关') { //网关
					var params = {
						code: this.codeS
					}
				} else if(val == '扩展录入1') { //扩展录入1
					var params = {
						code: this.equipmentCode
					}
				} else if(val == '扩展录入2') { //扩展录入2
					var params = {
						code: this.addrFour
					}
				}
				let config = headers.headers('getByCode')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/subproject/getByCode', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						if(val == '录入网关') { //网关
							if(this.boxShow && this.codeS == this.equimentCode) {
								this.notDo = false
								return
							}
							this.codeS = ''
						} else if(val == '扩展录入1') { //扩展录入1
							if(this.boxShow && this.equipmentCode == this.rowSubproject.code) {
								this.notDo = false
								return
							}
							this.equipmentCode = ''
						} else if(val == '扩展录入2') { //扩展录入2
							if(this.boxShow && this.addrFour == this.rowSeting.addr) {
								this.notDo = false
								return
							}
							this.addrFour = ''
						}
						this.notDo = true
						this.$message('该设备编号已存在,请重新输入设备编号！');
					} else {
						this.notDo = false
					}
				}).catch(err => {
					console.log(err)
				})
			},
			/*
			 * 新增设备
			 * */
			//新增设备
			addSetClick() {
				this.title = "新增设备"
				this.dialogFormVisible2 = true
				this.port = 'F2010201'
				this.rate_v = '1'
				this.rate_a = '1'
				this.checkedAll3=false
			},
			//设备列表
			getSetingList() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex2,
					gateway_id: this.gateway_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/device/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.getSetingTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.setingList = res.data
					} else {
						this.setingList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//全选、全不选
			changeClick3() {
				if(this.checkedAll3 == true) {
					this.equimentData.forEach(item => {
						item.selected = true
					})
				} else {
					this.equimentData.forEach(item => {
						item.selected = false
					})
				}
			},
			//单选
			checkedRadioChange3() {
				var checkedArr = []
				this.equimentData.forEach(item => {
					if(item.selected == true) {
						checkedArr.push(item)
					}
				})
				if(checkedArr.length == this.equimentData.length) {
					this.checkedAll3 = true
				} else {
					this.checkedAll3 = false
				}
			},
			getSetingTotal() {
				var params = {
					gateway_id: this.gateway_id
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/device/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total1 = res.data
					} else {
						this.total1 = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//分类的改变
			categoryChange(val) {
				if(val) {
					this.category_id = ''
				}
				this.product_id = ''
				//获取产品列表
				var params = {
					pageSize: -1,
					pageIndex: 1,
					category_id: this.category_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.projectData = res.data
					} else {
						this.projectData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//添加网关保存(把设备与网关关联起来/编辑)
			addGateSave() {
				var arr = []
				this.equimentData.forEach(item => {
					if(item.selected == true) {
						arr.push(item)
					}
				})
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				for(var i = 0; i < arr.length; i++) {
					axios.post(this.http + '/zkep2/device/save',
						qs.stringify({
							id: arr[i].id,
							gateway_id: this.gateway_id,
							port: this.port,
							rate_v: this.rate_v,
							rate_a: this.rate_a,
							p_code: this.p_code, //资产号
						}), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible2 = false
							this.getSetingList();
							this.deviceList();
						} else {
							this.$message('新增失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//复选框触发
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//批量删除
			batchDeleteClick(){
				if(this.multipleSelection.length > 0) {
					let config = headers.headers('save')
					var pass_token = config.pass_token
					var timestamp = config.timestamp
					this.$confirm('确认要删除吗?', '注意', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(() => {
						for(var i = 0; i < this.multipleSelection.length; i++) {
							axios.post(this.http + '/zkep2/device/save', qs.stringify({
								id: this.multipleSelection[i].id,
								gateway_id: 0,
							}), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
								//console.log(res)
								this.getSetingList();
								this.deviceList();
							}).catch(err => {
								console.log(err)
								this.$message({
									type: 'error',
									message: '删除失败!'
								});
								return
							})
						}
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				} else {
					this.$message({
						type: 'info',
						message: '请至少选择一条批量删除的数据!'
					});
				}
			},
			//批量扩展录入
			batchCopyClick() {
				this.large = false
				if(this.multipleSelection.length > 0) {
					this.dialogFormVisible4 = true
				} else {
					this.$message({
						type: 'info',
						message: '请至少选择一条批量扩展录入的数据!'
					});
				}
				this.title = "批量扩展录入"
				this.edit_id = ''
				this.nameFour = ''
				this.equipmentModel = ''
				this.rate_vFour = ''
				this.rate_aFour = ''
				this.addrFour = ''
				this.fee_num = ''
				this.user_type = ''
				this.rated_v = ''
				this.rated_a = ''
				this.p_code = ''
				this.password = ''
				this.portValue = ''
				this.join_type = ''
				this.rate_type = ''
				this.ruler_type = ''
				this.category_id = ''
				this.product_id = ''
				this.equipmentCode = ''
				/*左*/
				this.equipmentModelChecked = false
				this.category_idChecked = false
				this.product_idChecked = false
				this.rate_vFourChecked = false
				this.rate_aFourChecked = false
				this.addrFourChecked = false
				this.rate_typeChecked = false
				/*右*/
				this.ruler_typeChecked = false
				this.portValueChecked = false
				this.passwordChecked = false
				this.fee_numChecked = false
				this.user_typeChecked = false
				this.join_typeChecked = false
				this.rated_vChecked = false
				this.rated_aChecked = false
				this.p_codeChecked = false
			},
			//批量扩展录入全选
			checkedAllChange2() {
				if(this.checkedAll2 == true) {
					this.equipmentModelChecked = true
					this.category_idChecked = true
					this.product_idChecked = true
					this.rate_vFourChecked = true
					this.rate_aFourChecked = true
					this.addrFourChecked = true
					this.rate_typeChecked = true
					/*右*/
					this.ruler_typeChecked = true
					this.portValueChecked = true
					this.passwordChecked = true
					this.fee_numChecked = true
					this.user_typeChecked = true
					this.join_typeChecked = true
					this.rated_vChecked = true
					this.rated_aChecked = true
					this.p_codeChecked = true
				} else {
					this.equipmentModelChecked = false
					this.category_idChecked = false
					this.product_idChecked = false
					this.rate_vFourChecked = false
					this.rate_aFourChecked = false
					this.addrFourChecked = false
					this.rate_typeChecked = false
					/*右*/
					this.ruler_typeChecked = false
					this.portValueChecked = false
					this.passwordChecked = false
					this.fee_numChecked = false
					this.user_typeChecked = false
					this.join_typeChecked = false
					this.rated_vChecked = false
					this.rated_aChecked = false
					this.p_codeChecked = false
				}
			},
			checkedRadioChange2() {
				if(this.equipmentModelChecked && this.category_idChecked && this.product_idChecked && this.rate_vFourChecked && this.rate_aFourChecked && this.addrFourChecked && this.rate_typeChecked && this.ruler_typeChecked && this.portValueChecked && this.passwordChecked && this.fee_numChecked && this.user_typeChecked && this.join_typeChecked && this.rated_vChecked && this.rated_aChecked && this.p_codeChecked) {
					this.checkedAll2 = true
				} else {
					this.checkedAll2 = false
				}
			},
			/*
			 扩展录入
			 * */
			//子项目列表
			getSubproject(id) {
				var params = {}
				let config = headers.headers(id)
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/subproject/' + id, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.rowSubproject = res.data
						this.category_id = res.data.category_id //监测设备类型
						this.product_id = res.data.product_id //监测设备型号
						this.equipmentCode = res.data.code //设备编号
					} else {
						this.category_id = ''
						this.product_id = ''
						this.equipmentCode = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//扩展录入的点击
			enterClick(id, list) {
				this.large = true
				this.getSubproject(list.subproject_id);
				this.rowSeting = list
				this.title = "扩展录入"
				this.edit_id = id
				this.dialogFormVisible4 = true
				this.nameFour = list.name //名称
				this.equipmentModel = list.model //设备型号
				this.rate_vFour = list.rate_v //电压变比
				this.rate_aFour = list.rate_a //电流变比
				this.addrFour = list.addr //通讯地址
				this.fee_num = list.fee_num //费率个数
				this.user_type = list.user_type //用户类型
				this.rated_v = list.rated_v //额定电压 
				this.rated_a = list.rated_a //额定电流
				this.p_code = list.p_code //资产号
				this.password = list.password //通信密码
				this.portValue = list.port //端口
				this.join_type = list.join_type //接线方式
				this.rate_type = list.rate_type //波特率
				this.ruler_type = list.ruler_type //规约类型
			},
			//扩展录入的保存
			extendSave() {
				//this.gatewaySave2();
				if(this.large) {
					this.childSave2();
					this.finalSave2();
				} else {
					this.childSave3();
					this.finalSave3();
				}
			},
			//子项目更新保存
			childSave2() {
				var timestamp = Date.parse(new Date());
				var params = { //更新
					id: this.rowSeting.subproject_id,
					product_id: this.product_id,
					category_id: this.category_id,
					create_time: timestamp,
					code: this.equipmentCode,
					status: 1,
					version: 0,
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(!this.notDo) {
					axios.post(this.http + '/zkep2/subproject/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible = false
							this.getById();
						} else {
							this.$message('操作失败！')
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//批量子项目更新保存
			childSave3() {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {}
				for(var i = 0; i < this.multipleSelection.length; i++) {
					params['id'] = this.multipleSelection[i].subproject_id
					params['status'] = 1
					params['version'] = 0
					if(this.category_idChecked&&this.category_id) {
						params['category_id'] = this.category_id
					}
					if(this.product_idChecked&&this.product_id) {
						params['product_id'] = this.product_id
					}
					//console.log(params)
					if(!this.notDo) {
						axios.post(this.http + '/zkep2/subproject/save',
							qs.stringify(params), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
							//console.log(res)
							if(res.data.id) {
								this.dialogFormVisible = false
								this.getById();
							} else {
								this.$message('操作失败！')
							}
						}).catch(err => {
							console.log(err)
						})
					}
				}
			},
			//网关的保存(已弃用)
			gatewaySave2() {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					id: this.gateway_id,
					addr: this.equipmentCode,
				}
				axios.post(this.http + '/zkep2/gateway/save',
					qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res.data.id) {
						this.boxShow = true
						this.dialogFormVisible = false
						this.getGateway();
					} else {
						this.$message('新增失败！');
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//设备的保存
			finalSave2() {
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				var params = {
					id: this.edit_id,
					name: this.nameFour, //名称
					ruler_type: this.ruler_type, //规约类型
					password: this.password, //通信密码
					fee_num: this.fee_num, //费率个数
					user_type: this.user_type, //用户类型
					rate_type: this.rate_type, //波特率
					join_type: this.join_type, //接线方式
					rated_v: this.rated_v, //额定电压
					rated_a: this.rated_a, //额定电流
					p_code: this.p_code, //资产号
					port: this.portValue, //端口
					rate_v: this.rate_vFour, //电压变比
					rate_a: this.rate_aFour, //电流变比
					addr: this.addrFour, //通讯地址
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/device/save',
					qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res.data.id) {
						this.dialogFormVisible4 = false
						this.getSetingList();
					} else {
						this.$message('操作失败！');
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//批量设备的保存
			finalSave3() {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {}
				for(var i = 0; i < this.multipleSelection.length; i++) {
					params['id'] = this.multipleSelection[i].id
					params['status'] = 1
					if(this.rate_vFourChecked&&this.rate_vFour) {
						params['rate_v'] = this.rate_vFour
					}
					if(this.rate_aFourChecked&&this.rate_aFour) {
						params['rate_a'] = this.rate_aFour
					}
					if(this.addrFourChecked&&this.addrFour) {
						params['addr'] = this.addrFour
					}
					if(this.rate_typeChecked&&this.rate_type) {
						params['rate_type'] = this.rate_type
					}
					if(this.ruler_typeChecked&&this.ruler_type) {
						params['ruler_type'] = this.ruler_type
					}
					if(this.portValueChecked&&this.portValue) {
						params['port'] = this.portValue
					}
					if(this.passwordChecked&&this.password) {
						params['password'] = this.password
					}
					if(this.fee_numChecked&&this.fee_num) {
						params['fee_num'] = this.fee_num
					}
					if(this.user_typeChecked&&this.user_type) {
						params['user_type'] = this.user_type
					}
					if(this.join_typeChecked&&this.join_type) {
						params['join_type'] = this.join_type
					}
					if(this.rated_vChecked&&this.rated_v) {
						params['rated_v'] = this.rated_v
					}
					if(this.rated_aChecked&&this.rated_a) {
						params['rated_a'] = this.rated_a
					}
					if(this.p_codeChecked&&this.p_code) {
						params['p_code'] = this.p_code
					}
					//console.log(params)
					axios.post(this.http + '/zkep2/device/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible4 = false
							this.getSetingList();
						} else {
							this.$message('操作失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//删除(设备、方案、任务的删除)
			deleteClick(val, id, list) {
				var url;
				if(val == '设备') {
					url = "/zkep2/device/save"
					var params = {
						id: id,
						gateway_id: 0
					}
				} else if(val == '方案') {
					url = "/zkep2/plan/save"
					var params = {
						id: id,
						case_no: list.case_no + '_' + id,
						status: 0
					}
				} else if(val == '任务') {
					url = "/zkep2/task/save"
					var params = {
						id: id,
						status: 0
					}
				}
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				//console.log(params, url)
				this.$confirm('确认要删除吗?', '注意', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + url, qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {
							if(val == '设备') {
								this.getSetingList();
								this.deviceList();
							}
							if(val == '方案') {
								this.getCollectList();
							}
							if(val == '任务') {
								this.getTaskList();
							}
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			/*
			 * 方案
			 *  */
			//方案列表
			getCollectList() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					gateway_id: this.gateway_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/plan/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.getCollectTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.collectList = res.data
					} else {
						this.collectList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			getCollectTotal() {
				var params = {
					gateway_id: this.gateway_id
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/plan/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total2 = res.data
					} else {
						this.total2 = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//全选、全不选
			checkedAllChange() {
				if(this.checkedAll == true) {
					this.parserItemList.forEach(item => {
						item.checked = true
					})
				} else {
					this.parserItemList.forEach(item => {
						item.checked = false
					})
				}
			},
			//单选
			checkedRadioChange(val, signVal) {
				var checkedArr = []
				this.parserItemList.forEach(item => {
					if(item.checked == true) {
						checkedArr.push(item)
					}
				})
				if(checkedArr.length == this.parserItemList.length) {
					this.checkedAll = true
				} else {
					this.checkedAll = false
				}
			},
			//某解析下所有抄读项
			getAllItemWithFlag(parser_id) {
				var params = {
					parser_id: parser_id,
					plan_id: this.project_Id,
				}
				let config = headers.headers('getAllItemWithFlag')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/plan_column/getAllItemWithFlag', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							if(item.selected == 0) {
								item.selected = false
								item.checked = false
							} else if(item.selected == 1) {
								item.selected = true
								item.checked = true
							}
						})
						this.parserItemList = res.data
						this.checkedRadioChange()
					} else {
						this.parserItemList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//记录列筛选
			selectHandle() {
				this.dialogFormVisible10 = true
				this.title = '记录列筛选'
			},
			//方案的点击
			projectClick(id, list) {
				if(id) { //编辑
					this.project_Id = id
					this.parser_id = list.parser_id
					if(this.project_Id) {
						if(!this.parser_id) {
							this.getAllItemWithFlag(this.parser_idbackUp);
						} else {
							this.getAllItemWithFlag(this.parser_id);
						}
					}
					this.dialogFormVisible6 = true
					this.title = "方案编辑"
					this.case_type2 = list.case_type
					this.case_no = list.case_no
					this.store_depth = list.store_depth
					this.collect_type = list.collect_type
					this.collect_content = list.collect_content
					this.time_marker = list.time_marker
					this.ms = list.ms
					var arr = []
					var arr2 = []
					if(list.ms_user) {
						arr = list.ms_user.split(',')
						arr.forEach(item => {
							arr2.push({
								'oneVal': item
							})
						})
						this.userList = arr2
					} else {
						this.userList = []
						this.userList.push(new Sell());
					}
				} else { //添加
					if(this.setingList.length > 0) {
						this.title = "方案新增"
						this.dialogFormVisible6 = true
					} else {
						this.$message('请先新增设备！')
					}
					this.emptyProject();
				}
			},
			//清空
			emptyProject() {
				this.getParserItem();
				this.project_Id = ''
				this.case_type2 = ''
				this.case_no = ''
				this.store_depth = ''
				this.collect_type = ''
				this.collect_content = null
				this.time_marker = ''
				this.ms = ''
				this.userList = []
				this.userList.push(new Sell());
			},
			//方案的保存
			projectSave() {
				var userList = '';
				this.userList.forEach((item, index) => {
					if(item.oneVal) {
						if(index == this.userList.length - 1) {
							userList += item.oneVal
						} else {
							userList += item.oneVal + ','
						}
					}
				})
				if(this.ms == 1) {
					userList = ''
				}
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				if(this.collect_type == 0) {
					this.collect_content = null
				}
				if(this.project_Id) { //编辑
					var params = {
						id: this.project_Id,
						case_type: this.case_type2, //采集方案
						case_no: this.case_no, //方案编号
						store_depth: this.store_depth, //采集方案
						collect_type: this.collect_type, //采集方式
						collect_content: this.collect_content, //采集内容
						time_marker: this.time_marker, //存储时标
						ms: this.ms, //表计集合
						ms_user: userList,
						parser_id: this.parser_id,
						status: 1,
						version: 0
					}
				} else { //添加
					var params = {
						src: 3,
						b_manager_id: this.b_id,
						c_id: this.rowObj.c_id, //所属C端客户
						gateway_id: this.gateway_id, //所属网关
						case_type: this.case_type2, //采集方案
						case_no: this.case_no, //方案编号
						store_depth: this.store_depth, //采集方案
						collect_type: this.collect_type, //采集方式
						collect_content: this.collect_content, //采集内容
						ms: this.ms, //表计集合
						ms_user: userList,
						time_marker: this.time_marker, //存储时标
						isset: 0, //是否已下发 
						set_time: 0, //最近一次下发时间
						parser_id: this.parser_id,
						create_time: timestamp,
						status: 1,
						version: 0
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(this.case_type2 && this.case_no && this.store_depth && this.collect_type != undefined && this.time_marker != undefined) {
					axios.post(this.http + '/zkep2/plan/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible6 = false
							this.plan_idN = res.data.id
							if(this.plan_idN) {
								this.getCollectList();
								this.plan_columnSave();
							}
						} else {
							this.$message('操作失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$message('请输入填项！');
				}
			},
			//采集方案记录列的保存
			plan_columnSave() {
				var config = headers.headers('delByPlan')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/plan_column/delByPlan',
					qs.stringify({
						plan_id: this.plan_idN,
					}), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					this.getCollectList();
					//					if(res.data==0) {} else {
					//						this.$message('操作失败！');
					//					}
				}).catch(err => {
					console.log(err)
				})
				var arrAdd = []
				this.parserItemList.forEach(item => {
					if(item.checked == true) { //添加
						arrAdd.push(item)
					}
				})
				//console.log(arrAdd)
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				var config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				for(var i = 0; i < arrAdd.length; i++) {
					axios.post(this.http + '/zkep2/plan_column/save',
						qs.stringify({
							src: 3,
							b_manager_id: this.b_id,
							c_id: this.rowObj.c_id, //所属C端客户
							plan_id: this.plan_idN,
							code: arrAdd[i].code,
							create_time: timestamp,
							status: 1,
							version: 0
						}), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						this.getCollectList();
						if(res.data.id) {} else {
							this.$message('操作失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			/*
			 * 任务
			 * */
			//任务列表
			getTaskList() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					gateway_id: this.gateway_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/task/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.getTaskTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.taskList = res.data
					} else {
						this.taskList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			getTaskTotal() {
				var params = {
					gateway_id: this.gateway_id
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/task/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total3 = res.data
					} else {
						this.total3 = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//任务的点击
			taskClick(id, list) {
				if(id) { //编辑
					this.task_Id = id
					this.dialogFormVisible5 = true
					this.title = "任务编辑"
					this.plan_id = list.plan_id
					this.task_id = list.task_id
					this.step_type = list.step_type
					this.step = list.step
					this.case_type = list.case_type
					this.start_time = list.start_time
					this.end_time = list.end_time
					this.delay = list.delay
					this.delay_type = list.delay_type
					this.priority = list.priority
					var state;

					if(list.state == 1) {
						state = '正常'
					} else if(list.state == 2) {
						state = '停用'
					}
					this.state = state
					this.pre_id = list.pre_id
					this.suf_id = list.suf_id
					this.time_type = list.time_type
					this.time_start_h = list.time_start_h
					this.time_start_m = list.time_start_m
					this.time_end_h = list.time_end_h
					this.time_end_m = list.time_end_m
				} else { //添加
					if(this.setingList.length > 0) {
						this.taskEmpty();
						this.title = "任务新增"
						this.dialogFormVisible5 = true
					} else {
						this.$message('请先新增设备！')
					}
				}
			},
			//任务清空
			taskEmpty() {
				this.task_Id = ''
				this.plan_id = this.collectList[this.collectList.length - 1].id //所属方案
				this.task_id = '1' //任务ID
				this.step_type = 1 //时间间隔单位
				this.step = '30' //时间间隔数值
				this.case_type = 1 //方案类型
				this.start_time = '2001-01-01 12:00:00' //开始时间
				this.end_time = '2099-01-01 12:00:00' //结束时间
				this.delay = 0 //延时间隔数值
				this.delay_type = 0 //延时间隔单位
				this.priority = '0' //执行优先级
				this.state = '正常' //任务状态
				this.pre_id = '0' //任务开始前脚本ID
				this.suf_id = '0' //任务完成后脚本ID
				this.time_type = 0 //任务运行时段类型
				this.time_start_h = '0' //起始小时
				this.time_start_m = '0' //起始分钟
				this.time_end_h = '0' //结束小时
				this.time_end_m = '0' //结束分钟
				this.isset = '' //是否已下发
				this.set_time = '' //最近一次下发时间
			},
			/*任务保存*/
			taskSave() {
				var state;
				if(this.state == '停用') {
					state = 2
				} else if(this.state == '正常') {
					state = 1
				}
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				if(this.task_Id) { //编辑
					var params = {
						id: this.task_Id,
						plan_id: this.plan_id, //所属方案
						task_id: this.task_id, //任务ID
						step_type: this.step_type, //时间间隔单位
						step: this.step, //时间间隔数值
						case_type: this.case_type, //方案类型
						start_time: this.start_time, //开始时间
						end_time: this.end_time, //结束时间
						delay_type: Number(this.delay_type), //延时间隔单位
						delay: this.delay, //延时间隔数值
						priority: this.priority, //执行优先级
						state: state, //任务状态
						pre_id: this.pre_id, //任务开始前脚本ID
						suf_id: this.suf_id, //任务完成后脚本ID
						time_type: this.time_type, //任务运行时段类型
						time_start_h: this.time_start_h, //起始小时
						time_start_m: this.time_start_m, //起始分钟
						time_end_h: this.time_end_h, //结束小时
						time_end_m: this.time_end_m, //结束分钟
						status: 1,
						version: 0
					}
				} else { //添加
					var params = {
						src: 3,
						b_manager_id: this.b_id,
						c_id: this.rowObj.c_id, //所属C端客户
						gateway_id: this.gateway_id, //所属网关
						plan_id: this.plan_id, //所属方案
						task_id: this.task_id, //任务ID
						step_type: this.step_type, //时间间隔单位
						step: this.step, //时间间隔数值
						case_type: this.case_type, //方案类型
						start_time: this.start_time, //开始时间
						end_time: this.end_time, //结束时间
						delay_type: Number(this.delay_type), //延时间隔单位
						delay: this.delay, //延时间隔数值
						priority: this.priority, //执行优先级
						state: state, //任务状态
						pre_id: this.pre_id, //任务开始前脚本ID
						suf_id: this.suf_id, //任务完成后脚本ID
						time_type: this.time_type, //任务运行时段类型
						time_start_h: this.time_start_h, //起始小时
						time_start_m: this.time_start_m, //起始分钟
						time_end_h: this.time_end_h, //结束小时
						time_end_m: this.time_end_m, //结束分钟
						isset: 0, //是否已下发
						create_time: timestamp,
						status: 1,
						version: 0
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(this.plan_id && this.task_id && this.step_type != undefined && this.step && this.case_type &&
					this.start_time && this.end_time && this.delay_type != undefined && this.delay != undefined && this.priority != undefined &&
					state && this.pre_id != undefined && this.suf_id != undefined && this.time_type != undefined && this.time_start_h != undefined &&
					this.time_start_m != undefined && this.time_end_h != undefined && this.time_end_m != undefined) {
					axios.post(this.http + '/zkep2/task/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible5 = false
							this.getTaskList();
						} else {
							this.$message('操作失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$message('请输入填项！');
				}
			},
			//上报历史
			getHistoryList() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					gateway_id: this.gateway_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/command_log/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.getHistoryTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.historyList = res.data
						this.historyList.forEach((item, index) => {
							item.create_time = timeConvert.timeConvert(item.create_time)
						})
					} else {
						this.historyList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			getHistoryTotal() {
				var params = {
					gateway_id: this.gateway_id
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/command_log/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total4 = res.data
					} else {
						this.total4 = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style>
	.gateway {
		/*height: 100%;*/
		padding: 1% 2% 0 1%;
		position: relative;
		font-size: 13px;
		min-width: 700px;
		overflow: auto;
	}
	
	.gateway .headerBox3 {
		display: flex;
		position: relative;
		height: 200px;
		margin-bottom: 10px;
		background-color: #fff;
	}
	
	.gateway .leftContent {
		position: relative;
		flex: 1;
		vertical-align: top;
		display: inline-block;
		height: 100%;
	}
	
	.gateway .modelClass {
		margin: 2% 0 4% 3%;
		color: #808080;
	}
	
	.gateway .setNameClass {
		font-size: 14px;
		font-weight: 600;
		margin-left: 3%;
	}
	
	.textClass1 {
		margin-top: 20px;
		font-size: 13px;
		color: #999;
		margin-left: 3%;
		height: 22px;
	}
	
	.textClass {
		font-size: 13px;
		color: #999;
		margin-left: 3%;
		height: 22px;
	}
	
	.gateway .typeClass {
		position: relative;
		margin: 6% 0 3% 3%;
		color: #808080;
	}
	
	.gateway .typeClass2 {
		position: absolute;
		top: 6%;
		right: 8%;
		color: #808080;
	}
	
	.gateway .rightContent {
		position: relative;
		display: inline-block;
		flex: 1;
		height: 100%;
	}
	
	.gateway .editClass {
		color: #439DFD;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.gateway .setStatusClass {
		margin-top: 2%;
	}
	
	.gateway .outLineClass {
		margin-top: 10px;
	}
	
	.gateway .MeiClass {
		color: #999;
		font-size: 12px;
		margin-bottom: 2px;
	}
	
	.gateway .wifiClass {
		font-size: 16px;
		margin-right: 6px;
	}
	
	.gateway .wifiClass2 {
		margin-right: 6px;
		vertical-align: bottom;
		font-size: 20px;
	}
	
	.gateway .relationButton,
	.gateway .relationButton1,
	.gateway .relationButton2,
	.gateway .relationButton3,
	.gateway .relationButton4,
	.gateway .relationButton5 {
		position: absolute;
		bottom: 10px;
		right: 215px;
		width: 90px;
		padding: 6px 14px;
		font-size: 12px;
	}
	
	.gateway .relationButton4 {
		bottom: 1px;
		padding-left: 9px;
		right: 415px;
	}
	
	.gateway .relationButton5 {
		bottom: 1px;
		padding-left: 9px;
		right: 312px;
	}
	
	.gateway .relationButton1 {
		right: 111px;
	}
	
	.gateway .relationButton2 {
		right: 7px;
	}
	
	.gateway .relationButton3 {
		right: 320px;
	}
	/*tabs*/
	
	.gateway .el-radio-button:first-child .el-radio-button__inner {
		border-radius: 0;
	}
	
	.gateway .el-radio-button:last-child .el-radio-button__inner {
		border-radius: 0;
	}
	
	.gateway .el-radio-button__inner {
		background-color: #eee;
		padding: 10px 30px;
		font-size: 13px;
	}
	
	.gateway .el-radio-button__orig-radio:checked+.el-radio-button__inner {
		background-color: #457ED8;
		border-color: #457ED8;
	}
	
	.gateway .tabButtonBox {
		position: absolute;
		top: 0;
		right: 7px;
	}
	
	.gateway .tabButton {
		width: 90px;
		padding: 6px 14px;
		font-size: 12px;
	}
	
	.gateway .tabButton2 {
		width: 100px;
		padding: 6px 14px;
		font-size: 12px;
	}
	
	.gateway .el-table th {
		color: #000;
	}
	
	.gateway .el-table {
		font-size: 12px;
	}
	
	.gateway .el-table th,
	.gateway .el-table td,
	.gateway .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.gateway .el-table th {
		text-align: left;
		padding: 10px 0!important;
		font-weight: 400;
		color: #999;
	}
	
	.gateway .el-dialog__title {
		color: #999;
	}
	
	.gateway .el-dialog__body {
		font-size: 13px;
	}
	
	.gateway .el-dialog__footer {
		text-align: center;
	}
	
	.gateway .pagination {
		margin-bottom: 20px;
		text-align: center;
	}
	
	.gateway .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
	
	.gateway .specil {
		margin-top: 20px;
		margin-bottom: 20px;
	}
	
	.gateway .specil .el-input__inner {
		width: 287px;
		height: 32px;
		line-height: 32px;
	}
	
	.gateway .specilInput {
		margin-bottom: 20px;
	}
	
	.gateway .inputClass {
		text-indent: 10px;
		outline: none;
		padding: 6px 0;
		border: 1px solid #DCDCDC;
		width: 36%;
		border-radius: 2px;
	}
	
	.gateway .lineClass {
		margin-bottom: 20px;
		width: 100%;
		height: 1px;
		background-color: #ccc;
	}
	
	.gateway .ergencyLi {
		display: inline-block;
		padding-left: 6px;
		height: 32px;
		line-height: 32px;
		width: 22%;
		border: 1px solid #439DFD;
		background-color: #fff;
		border-radius: 3px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	/*复选框（原色）*/
	
	.gateway .el-checkbox {
		color: #439DFD;
	}
	
	.gateway .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
	}
	
	.gateway .el-checkbox__inner {
		border: 1px solid #439DFD!important;
		background-color: #439DFD;
		border-radius: 0!important;
	}
	
	.gateway .el-checkbox__input.is-checked .el-checkbox__inner,
	.gateway .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #439DFD;
		border-color: #439DFD!important;
	}
	
	.gateway .transDialog .el-dialog__footer {
		text-align: right;
	}
	
	.gateway .textarea1 {
		border: 1px solid #ccc;
		height: 300px!important;
		overflow-y: auto;
	}
	/*//文本域*/
	
	.gateway .textarea1 .el-textarea__inner {
		resize: none;
		height: 300px!important;
		border-radius: 0;
	}
	
	.gateway .textarea2 .el-textarea__inner {
		resize: none;
		width: 88%;
		height: 80px!important;
		border-radius: 0;
	}
	
	.gateway .dialog-footer {
		position: relative;
	}
	
	.gateway .dialog-footer .confrim1 {
		position: absolute;
		bottom: 0;
		right: 0;
	}
	
	.gateway .dialogFour .el-dialog {
		margin-top: 30px!important;
	}
	
	.gateway .dialogFour .el-input__inner {
		height: 32px;
		line-height: 32px;
	}
	
	.gateway .dialogFour .el-form-item {
		margin-bottom: 18px;
	}
	
	.gateway .rollBox {
		height: 340px;
		overflow: auto;
	}
	
	.gateway .ergencyLi2 {
		display: inline-block;
		padding-left: 6px;
		height: 32px;
		line-height: 32px;
		width: 28%;
		border: 1px solid #439DFD;
		background-color: #fff;
		border-radius: 3px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	/*复选框（深色）*/
	
	.gateway .specilCheckBox .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
		color: #000;
	}
	
	.gateway .specilCheckBox .el-checkbox__inner {
		border: 1px solid #0079DD!important;
		background-color: #0079DD;
		border-radius: 0!important;
	}
	
	.gateway .specilCheckBox .el-checkbox__input.is-checked .el-checkbox__inner,
	.gateway .specilCheckBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #0079DD;
		border-color: #0079DD!important;
	}
	
	.gateway .nameClass2 {
		margin-left: 24px;
		font-size: 12px;
		height: 2px;
		line-height: 2px;
	}
	
	.gateway .nameClass22 {
		margin-left: 24px;
		font-size: 12px;
		height: 0px;
		line-height: 0px;
	}
	
	.gateway .nameClass33 {
		color: #439DFD;
		margin-left: 24px;
		font-size: 12px;
		height: 0px;
		line-height: 0px;
	}
	
	.gateway .parserClass {
		display: inline-block;
		width: 150px;
		height: 30px;
		line-height: 26px;
		padding: 4px 0 8px 4px;
		margin: 0 3px 6px 4px;
		border: 1px solid #439DFD;
		border-radius: 4px;
	}
	
	.gateway .checkAllBox {
		margin-left: 2px;
		margin-bottom: 16px;
	}
	
	.gateway .checkAllBox .el-checkbox__inner,
	.gateway .checkAllBox2 .el-checkbox__inner {
		border: 1px solid #6a6a6a!important;
		background-color: #6a6a6a;
		border-radius: 0!important;
	}
	
	.gateway .checkAllBox .el-checkbox__input.is-checked+.el-checkbox__label,
	.gateway .checkAllBox2 .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #409eff;
	}
	
	.gateway .checkAllBox .el-checkbox__label,
	.gateway .checkAllBox2 .el-checkbox__label {
		color: #6a6a6a;
	}
	
	.gateway .parserClass2 {
		display: inline-block;
		width: 210px;
		height: 30px;
		line-height: 26px;
		padding: 4px 0 8px 4px;
		margin: 0 10px 6px 4px;
		border: 1px solid #439DFD;
		border-radius: 4px;
	}
	
	.gateway .parserClass3 {
		display: inline-block;
		width: 210px;
		height: 30px;
		line-height: 26px;
		padding: 4px 0 8px 4px;
		margin: 0 10px 6px 4px;
		border: 1px solid #6A6A6A;
		border-radius: 4px;
	}
	
	.gateway .el-checkbox__input.is-disabled+span.el-checkbox__label {
		color: #666;
		cursor: not-allowed;
	}
	
	.gateway .parserClass3 .el-checkbox {
		color: #6A6A6A;
	}
	
	.gateway .parserClass3 .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
	}
	
	.gateway .parserClass3 .el-checkbox__inner {
		border: 1px solid #6A6A6A!important;
		background-color: #6A6A6A;
		border-radius: 0!important;
	}
	
	.gateway .parserClass3 .el-checkbox__input.is-checked .el-checkbox__inner,
	.gateway .parserClass3 .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #6A6A6A;
		border-color: #6A6A6A!important;
	}
	
	.gateway .transDialog .el-dialog__footer {
		text-align: right;
	}
	/*加载图标*/
	
	.el-loading-spinner {
		font-size: 46px;
	}
	
	.el-loading-spinner i {
		color: #34495e!important;
		opacity: 0.7;
	}
	
	.gateway .el-button.is-circle {
		border-radius: 50%;
		padding: 6px;
	}
	
	.gateway .tabPositionClass .el-checkbox__inner {
		border: 1px solid #ccc!important;
		background-color: #fff;
		border-radius: 0!important;
	}
	
	.gateway .checkAllBox2 {
		margin-left: 1.3%;
		margin-bottom: 16px;
	}
	
	.gateway .largeCheckBoxClass {
		position: relative;
	}
	
	.gateway .largeCheckClass {
		position: absolute;
		top: 11px;
		left: 3%;
	}
	
	.gateway .largeCheckBoxClass .el-checkbox__inner {
		border: 1px solid #ccc!important;
		background-color: #fff;
		border-radius: 0!important;
	}
	/*滚动条的样式*/
	
	.gateway::-webkit-scrollbar {
		width: 10px;
	}
	
	.gateway::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}
	
	.gateway::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
	/*媒体查询*/
	
	@media screen and (max-width: 1350px) {
		.gateway .tabButtonBox {
			position: absolute;
			top: 40px;
			left: 0px;
		}
		.gateway .tabPositionClass {
			margin-top: 40px;
		}
		.gateway .tabButton {
			width: 80px;
		}
	}
	
	@media screen and (max-width: 1297px) {
		.gateway .largeCheckClass {
			position: absolute;
			top: 11px;
			left: -5%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Customer/Gateway.vue